/* global getCookie */
const cookieIdentity = getCookie('mtracker');

if (cookieIdentity === 'bannerDismissed') {
  document.querySelector('.flash-banner-bg').style.display = 'none';
}

const checkDevice = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf('android') > -1;

  if (isAndroid) {
    document.querySelector('body').classList.add('enfa-android-device');
  }
};

document.addEventListener('DOMContentLoaded', checkDevice);
